import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (keyword, spaceStatus, page, perPage, all, spaceId) => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/list", {
    headers: authHeader(),
    data: {},
    params: {
      keyword: keyword,
      spaceStatus,
      page: page,
      perPage: perPage,
      all,
      ...(spaceId ? { spaceId } : {}),
    },
  });
};

const fetchSpaceById = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `space/view?spaceId=${id}`, {
    headers: authHeader(),
  });
};

const updateSpaceStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/updateStatus/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const deleteSpace = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `space/delete/${id}`, {
    headers: authHeader(),
    data,
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `space/restore/${id}`, {
    headers: authHeader(),
    params: data,
  });
};

const updateSpaceSearchableStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-searchable/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const updateSpaceClaimListingStatusService = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-claim-listing-status/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const updateOneTimeReservationService = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-one-time-reservation/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const updateIsAddressVisible = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-is-address-visible/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const updateIsAvailable = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-is-available/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const updateAutoApproval = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `space/update-auto-approval/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const transferOwnerShipService = (data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `space/transfer-owner`,
    data,
    { headers: authHeader() }
  );
};

const updateSpace = (id, data) => {
  console.log(id,data,"Dfdfdfd");
  
  return axios.put(
    process.env.REACT_APP_API_URL + `admin/space/update/${id}`,
    data,
    {
      headers: multipartHeader(),
    }
  );
};

const deleteSpaceMedia = (spaceId, mediaName) => {
  return axios.delete(
    process.env.REACT_APP_API_URL + `admin/space/${spaceId}/media`,
    {
      headers: authHeader(),
      data: { mediaName },
    }
  );
};



const fetchSpacePlans = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `admin/space/stripe-info/${id}`, {
    headers: authHeader(),
  });
};

const copySpace = (data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `admin/space/copy`,
    data,
    { headers: authHeader() }
  );
};

const sendAccessInfo = (id) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `space/send-access-info/${id}`,
    {},
    {
      headers: authHeader(),
    }
  );
};

const searchLocationAlerts = (keyword = "") => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/location-alert-search", {
    headers: authHeader(),
    params: { keyword },
  });
};

const sendLocationAlert = (data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + "spaces/send-location-alert",
    data,
    { headers: multipartHeader() }
  );
};

const getMonthlyRatePreview = (id) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `space/${id}/rate-update-preview`,
    {
      headers: authHeader(),
    }
  );
};

const updateMonthlyRate = (id) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `space/${id}/update-monthly-rate`,
    {},
    {
      headers: authHeader(),
    }
  );
};

const getPriceChangeNotificationPreview = (id) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `space/${id}/price-change-notification-preview`,
    {
      headers: authHeader(),
    }
  );
};

const sendPriceChangeNotifications = (id, data = {}) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `space/${id}/price-change-notifications`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const getPriceNotificationHistory = (id) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `space/${id}/price-notification-history`,
    {
      headers: authHeader(),
    }
  );
};

const bulkUpdateMonthlyRate = (spaceIds) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `spaces/bulk-update-monthly-rate`,
    { spaceIds },
    {
      headers: authHeader(),
    }
  );
};


const getAllSpaces = (keyword, spaceStatus, page, perPage, all) => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/getAllListing", {
    headers: authHeader(),
    data: {},
    params: {
      keyword: keyword,
      spaceStatus,
      page: page,
      perPage: perPage,
      all,
    },
  });
};

const exportSpaces = (filters = {}) => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/export", {
    headers: authHeader(),
    responseType: "blob",
    params: filters,
  });
};

const downloadImportTemplate = () => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/import/template", {
    headers: authHeader(),
    responseType: "blob",
  });
};

// commit = false -> preview/validate only; commit = true -> create drafts
const importSpaces = (file, commit = false) => {
  const body = new FormData();
  body.append("file", file);
  body.append("commit", commit ? "true" : "false");
  return axios.post(process.env.REACT_APP_API_URL + "spaces/import", body, {
    headers: multipartHeader(),
  });

};  

const downloadPriceTemplate = () => {
  return axios.get(process.env.REACT_APP_API_URL + "spaces/price-template", {
    headers: authHeader(),
    responseType: "blob",
  });
};

const previewBulkPrices = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(
    process.env.REACT_APP_API_URL + "spaces/bulk-update-prices/preview",
    formData,
    {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const generateShareLink = (data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + "admin/space/share-link",
    data,
    {
      headers: authHeader(),
    }
  );
};

const bulkUpdatePrices = (items) => {
  return axios.post(
    process.env.REACT_APP_API_URL + "spaces/bulk-update-prices",
    { items },
    {
      headers: authHeader(),
    }
  );
};

export default {
  getAll,
  fetchSpaceById,
  updateSpaceStatus,
  deleteSpace,
  restore,
  updateSpaceSearchableStatus,
  updateSpaceClaimListingStatusService,
  transferOwnerShipService,
  updateSpace,
  deleteSpaceMedia,
  fetchSpacePlans,
  copySpace,
  updateOneTimeReservationService,
  updateIsAddressVisible,
  updateIsAvailable,
  sendAccessInfo,
  updateAutoApproval,
  getAllSpaces,
  exportSpaces,
  downloadImportTemplate,
  importSpaces,
  getMonthlyRatePreview,
  updateMonthlyRate,
  getPriceChangeNotificationPreview,
  sendPriceChangeNotifications,
  getPriceNotificationHistory,
  searchLocationAlerts,
  sendLocationAlert,
  bulkUpdateMonthlyRate,
  downloadPriceTemplate,
  previewBulkPrices,
  generateShareLink,
  bulkUpdatePrices,
};
